module.exports = __webpack_public_path__ + "static/media/logo-white.f7447b19.svg";